// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"e0a38d92","452":"58b18c84"}[chunkId] + ".chunk.css";
};